import React, { useRef, useMemo, useState, useEffect } from "react";
import debounce from "lodash.debounce";
import ReactPlayer from "react-player";
import Image from "../images/Image";
import Icon from "@mdi/react";
import { mdiClose } from "@mdi/js";
import Slider from "react-slick";
import { LeftArrow, RightArrow } from "./Arrows";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import useMedia from "../../hooks/useMedia";

const sliderSettings = {
  adaptiveHeight: true,
  infinite: false,
  arrows: false,
};

const Slide = ({
  image,
  image2,
  image3,
  video_url,
  content,
  hide,
  previousWork,
  nextWork,
  isFirst: isFirstProject,
  isLast: isLastProject,
  isFocused,
}) => {
  const slider = useRef();
  const media = useMedia();
  const [index, setIndex] = useState(0);
  const imageCount = useMemo(() => {
    let i = 0;
    if (!!image) i++;
    if (!!image2) i++;
    if (!!image3) i++;
    if (!!video_url) i++;
    return i;
  }, [image, image2, image3, video_url]);
  const isLastInProject = index >= imageCount - 1;
  const isFirstInProject = index === 0;

  const onPrev = () => {
    if (isFirstInProject) previousWork();
    else {
      if (slider.current) slider.current.slickGoTo(index - 1);
      setIndex(index - 1);
    }
  };

  const onNext = () => {
    if (isLastInProject) nextWork();
    else {
      if (slider.current) slider.current.slickGoTo(index + 1);
      setIndex(index + 1);
    }
  };

  // eslint-disable-next-line
  const keyAction = debounce(
    event => {
      if (event.keyCode === 39) onNext();
      else if (event.keyCode === 37) onPrev();
    },
    500,
    { leading: true }
  );

  useEffect(() => {
    if (isFocused) document.addEventListener("keydown", keyAction);
    else document.removeEventListener("keydown", keyAction);
    return () => document.removeEventListener("keydown", keyAction);
  }, [keyAction, isFocused]);

  return (
    <div className="slide">
      <div className="slide_wrapper">
        <div className="slide_close" onClick={hide}>
          <Icon path={mdiClose} size="24px" color="white" />
        </div>
        {(!isFirstProject || !isFirstInProject) && (
          <LeftArrow
            onClick={onPrev}
            text={isFirstInProject ? "<- Previous project" : null}
          />
        )}
        <Slider {...sliderSettings} ref={slider}>
          {!!video_url && (
            <ReactPlayer
              url={video_url}
              width="100%"
              height={media === "mobile" ? "20rem" : "36rem"}
              playing={isFocused && index === 0}
              controls
            />
          )}
          {!!image && (
            <Image
              image={image}
              className="slide_image"
              alt="slideshow image"
            />
          )}
          {!!image2 && (
            <Image
              image={image2}
              className="slide_image"
              alt="slideshow image"
            />
          )}
          {!!image3 && (
            <Image
              image={image3}
              className="slide_image"
              alt="slideshow image"
            />
          )}
        </Slider>
        {!(isLastInProject && isLastProject) && (
          <RightArrow
            onClick={onNext}
            text={isLastInProject ? "Next project ->" : null}
          />
        )}
        <div className="slide_content">{content}</div>
      </div>
    </div>
  );
};

export default Slide;
